m = require("mithril")
s = require("./settings")

let state = {
	current: 0,
	players: s.players,
	counting: false
}

module.exports = state


//////////////////
// WEBPACK FOOTER
// ./src/model/state.js
// module id = 10
// module chunks = 0